export const textSizePrimitives = {
  // Font sizes (in rem units)
  fontSize: {
    h1: '3rem', // Large size for main headings
    h2: '2.5rem', // Secondary headings
    h3: '2rem', // Standard heading size
    p: '1rem', // Standard paragraph size
    subtitle: '1.5rem', // Subtitle text size
    caption: '0.875rem', // Smallest size for captions
  },

  // Font weights
  fontWeight: {
    regular: 'normal', // Normal weight for body text and subtitles
    bold: 'bold', // Bold weight for headings and emphasized text
  },

  // Line heights (for readability)
  lineHeight: {
    h1: '1.2', // Tight line height for large headings
    h2: '1.3', // Slightly more space between lines for h2
    h3: '1.4', // Normal line height for standard heading
    p: '1.6', // Comfortable line height for paragraphs
    subtitle: '1.5', // Line height for subtitles
    caption: '1.4', // Small line height for captions
  },

  // Letter Spacing (adjust for readability or design needs)
  letterSpacing: {
    h1: '-0.02em', // Slightly negative letter spacing for h1
    h2: '-0.01em', // Slightly negative letter spacing for h2
    h3: '0', // Normal letter spacing for h3
    p: '0', // Normal letter spacing for paragraph
    subtitle: '0', // Normal letter spacing for subtitle
    caption: '0.05em', // Small positive letter spacing for captions
  },
};
